import AnchorLink from "react-anchor-link-smooth-scroll";
import { Link } from "react-router-dom";
import MobileMenu from "../../components/MobileMenu";

import "./style.css";

const Header = () => {
  return (
    <div className="Header_root">
      <div className="header">
        <div className="container">
          <div className="row">
            <div className="col-lg-5 col-10">
              <div className="logo">
                <h2>
                  <Link to="/">
                    Linh Phương
                    <span>
                      <i className="fa fa-heart" aria-hidden="true"></i>
                    </span>
                    Huy Hanh
                  </Link>
                </h2>
              </div>
            </div>
            <div className="col-lg-7">
              <div className="header-menu d-lg-block d-none">
                <ul className="mobail-menu d-flex">
                  <li>
                    <AnchorLink href="#couple">Chúng mình</AnchorLink>
                  </li>
                  <li>
                    <AnchorLink href="#story">Chuyện tình</AnchorLink>
                  </li>
                  <li>
                    <AnchorLink href="#journey">Kệ sách hành trình</AnchorLink>
                  </li>
                  <li>
                    <AnchorLink href="#gallery">Kỷ niệm</AnchorLink>
                  </li>
                  <li>
                    <AnchorLink href="#rsvp">Sổ lưu bút</AnchorLink>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-2">
              <MobileMenu />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
